export default function HeadingSection() {
  return (
    <section className="flex w-full flex-col items-center gap-2 pb-9">
      <h1 className="w-full text-center typo-heading-1 text-g-00">
        탑콜렉터
      </h1>
      <div className="flex w-full flex-col items-center gap-0.5">
        <p className="w-full text-center typo-body-5 text-g-00">
          홈 경기장에서 누리는 특별한 경험!
        </p>
        <p className="w-full text-center typo-body-5 text-g-00">
          지금 탑콜렉터에 도전해보세요!
        </p>
      </div>
    </section>
  );
}
